import axios from 'axios';
import { keys } from '../config/keys';

let activeRequests = 0;
let loaderListener = null;

export const setLoaderListener = (listener) => {
  loaderListener = listener;
};

const api = axios.create({
  baseURL: keys.ServicePath,
});

const shouldSkipLoader = (config = {}) => {
  if (config.skipLoader) return true;
  const url = config.url || '';
  return (
    url.includes('/map') ||
    url.includes('/leaflet') ||
    url.includes('/geo') ||
    url.includes('/popupmap')
  );
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!shouldSkipLoader(config)) {
      activeRequests++;
      if (loaderListener) loaderListener(true);
    }
    return config;
  },
  (error) => {
    if (!shouldSkipLoader(error.config || {})) {
      activeRequests = Math.max(0, activeRequests - 1);
      if (activeRequests === 0 && loaderListener) loaderListener(false);
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (!shouldSkipLoader(response.config || {})) {
      activeRequests = Math.max(0, activeRequests - 1);
      if (activeRequests === 0 && loaderListener) loaderListener(false);
    }
    return response;
  },
  (error) => {
    if (!shouldSkipLoader(error.config || {})) {
      activeRequests = Math.max(0, activeRequests - 1);
      if (activeRequests === 0 && loaderListener) loaderListener(false);
    }
    return Promise.reject(error);
  }
);

export default api;